"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAndroidWebView = exports.isIOSWebView = exports.isScrileWebView = exports.isWindows = exports.isFirefox = exports.isMacOS = exports.isSafari = exports.isMobile = exports.isAndroid = exports.isIOS = void 0;
function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent);
}
exports.isIOS = isIOS;
function isAndroid() {
    return /Android/.test(navigator.userAgent);
}
exports.isAndroid = isAndroid;
function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/.test(navigator.userAgent);
}
exports.isMobile = isMobile;
function isSafari() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf("safari") > -1 && ua.indexOf("chrome") === -1;
}
exports.isSafari = isSafari;
function isMacOS() {
    return navigator.platform.toLocaleLowerCase().indexOf("mac") > -1;
}
exports.isMacOS = isMacOS;
function isFirefox() {
    return /Firefox/.test(navigator.userAgent);
}
exports.isFirefox = isFirefox;
function isWindows() {
    return navigator.platform.toLocaleLowerCase().indexOf("win32") > -1;
}
exports.isWindows = isWindows;
function isScrileWebView() {
    return /scrile-connect/.test(navigator.userAgent);
}
exports.isScrileWebView = isScrileWebView;
function isIOSWebView() {
    return isIOS() && !isSafari();
}
exports.isIOSWebView = isIOSWebView;
function isAndroidWebView() {
    return isAndroid() && /vw/.test(navigator.userAgent);
}
exports.isAndroidWebView = isAndroidWebView;
//# sourceMappingURL=browserUtils.js.map